export default __webpack_public_path__ + "static/media/dotsDropdown.3de78056.svg";